"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyType = exports.AnyArrayType = exports.BooleanType = exports.NumberType = exports.StringType = exports.VoidType = void 0;
exports.VoidType = "void";
exports.StringType = { type: "string" };
exports.NumberType = { type: "number" };
exports.BooleanType = { type: "boolean" };
exports.AnyArrayType = "array";
exports.AnyType = "any";
//# sourceMappingURL=type.js.map